function calculateServiceCharge(serviceCharge, price, originalPrice) {
	if (serviceCharge === undefined) return 0
	var response = 0
	response =
		serviceCharge.type.toLowerCase() == 'percentual'
			? roundMoneyFuncion(
					(serviceCharge.value / 100) * (price > 0 ? price : originalPrice)
			  )
			: serviceCharge.value

	return parseFloat(response)
}

const roundMoneyFuncion = (value) =>
	Math.round((value + Number.EPSILON) * 100) / 100

export const serviceChargeHelper = { calculateServiceCharge }
